module.exports = __webpack_public_path__ + "img/finance3.4596232d.png";